import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "card mb-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-4 pb-2 min-h-auto" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column my-2" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-4 mb-0" }, "Abonelik"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold fs-8" }, " Planınızı seçin, dilediğiniz zaman değiştirin veya iptal edin ")
  ])
], -1)
const _hoisted_3 = { class: "card-body pt-2" }
const _hoisted_4 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_5 = { class: "d-flex align-items-center mb-3 flex-wrap" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-gray-900 mb-0 fs-5" }, "TekPanel ile neler yaptınız?", -1)
const _hoisted_7 = {
  key: 0,
  class: "badge badge-light-primary ms-3 fs-8"
}
const _hoisted_8 = { class: "row g-3" }
const _hoisted_9 = {
  key: 0,
  class: "col-lg-5"
}
const _hoisted_10 = { class: "d-flex flex-column justify-content-center bg-light-primary rounded p-5 h-100" }
const _hoisted_11 = { class: "d-flex align-items-center mb-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "fs-3hx me-3 lh-1" }, "⏱️", -1)
const _hoisted_13 = { class: "fs-2hx fw-bolder text-primary lh-1" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-800 fw-bold" }, " TekPanel sayesinde kazandığınız tahmini zaman ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "fs-8 text-muted" }, " Her işlem diğer panellerde ortalama ~30 saniye sürer; TekPanel'de tek tıkla hallediyorsunuz. ", -1)
const _hoisted_16 = { class: "row g-3" }
const _hoisted_17 = { class: "col-6" }
const _hoisted_18 = { class: "border border-dashed border-gray-300 rounded p-4 h-100" }
const _hoisted_19 = { class: "fs-2x fw-bolder text-primary" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "fs-8 text-muted fw-semibold" }, "toplam işlem", -1)
const _hoisted_21 = { class: "col-6" }
const _hoisted_22 = { class: "border border-dashed border-gray-300 rounded p-4 h-100" }
const _hoisted_23 = { class: "fs-2x fw-bolder text-gray-900" }
const _hoisted_24 = { class: "fs-8 text-muted fw-semibold" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" kez ürün açma/kapama ")
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "col-6" }
const _hoisted_28 = { class: "border border-dashed border-gray-300 rounded p-4 h-100" }
const _hoisted_29 = { class: "fs-2x fw-bolder text-gray-900" }
const _hoisted_30 = { class: "fs-8 text-muted fw-semibold" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" kez fiyat güncelleme ")
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "col-6" }
const _hoisted_34 = { class: "border border-dashed border-gray-300 rounded p-4 h-100" }
const _hoisted_35 = { class: "fs-2x fw-bolder text-gray-900" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "fs-8 text-muted fw-semibold" }, "kez opsiyon açma/kapama", -1)
const _hoisted_37 = {
  key: 0,
  class: "col-6"
}
const _hoisted_38 = { class: "border border-dashed border-gray-300 rounded p-4 h-100" }
const _hoisted_39 = { class: "fs-2x fw-bolder text-gray-900" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "fs-8 text-muted fw-semibold" }, "yoruma cevap", -1)
const _hoisted_41 = {
  key: 1,
  class: "col-6"
}
const _hoisted_42 = { class: "border border-dashed border-success rounded p-4 h-100 bg-light-success" }
const _hoisted_43 = { class: "fs-2x fw-bolder text-success" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "fs-8 text-muted fw-semibold" }, " işlemi sizin yerinize otomatik yaptık ", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-6" }, null, -1)
const _hoisted_46 = {
  key: 1,
  class: "notice d-flex bg-light-success rounded border-success border border-dashed p-6 mb-8"
}
const _hoisted_47 = { class: "d-flex flex-stack flex-grow-1 flex-wrap" }
const _hoisted_48 = { class: "fw-bold" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("h4", { class: "text-gray-800 fw-bolder" }, "Aktif Aboneliğiniz", -1)
const _hoisted_50 = { class: "fs-6 text-gray-700" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = {
  key: 2,
  class: "notice d-flex bg-light-warning rounded border-warning border border-dashed p-6 mb-8"
}
const _hoisted_53 = { class: "fw-bold" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("h4", { class: "text-gray-800 fw-bolder" }, "Aboneliğiniz İptal Edildi", -1)
const _hoisted_55 = { class: "fs-6 text-gray-700" }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" tarihinde sona erecek ve otomatik yenilenmeyecek. Dilediğiniz zaman aşağıdan tekrar abone olabilirsiniz. ")
const _hoisted_58 = {
  key: 3,
  class: "notice d-flex bg-light-danger rounded border-danger border border-dashed p-6 mb-8"
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-gray-800 fw-bolder" }, "Hesabınız Görüntüleme Modunda"),
  /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-700" }, " Aktif aboneliğiniz bulunmuyor. Ürün açma/kapama, fiyat güncelleme gibi işlemleri yapabilmek için lütfen aşağıdan bir plan seçin. ")
], -1)
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = {
  key: 4,
  class: "notice d-flex bg-light-warning rounded border-warning border border-dashed p-6 mb-8"
}
const _hoisted_62 = { class: "fw-bold" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("h4", { class: "text-gray-800 fw-bolder" }, "Deneme / Geçiş Süreniz Devam Ediyor", -1)
const _hoisted_64 = { class: "fs-6 text-gray-700" }
const _hoisted_65 = { class: "d-flex justify-content-center mb-10" }
const _hoisted_66 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_67 = /*#__PURE__*/_createTextVNode(" Yıllık ")
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-success ms-2" }, "2 ay bedava", -1)
const _hoisted_69 = [
  _hoisted_67,
  _hoisted_68
]
const _hoisted_70 = { class: "row g-6" }
const _hoisted_71 = { class: "card-body d-flex flex-column" }
const _hoisted_72 = { class: "d-flex align-items-center mb-4" }
const _hoisted_73 = { class: "fw-bolder text-gray-900 mb-0" }
const _hoisted_74 = {
  key: 0,
  class: "badge badge-primary ms-3"
}
const _hoisted_75 = { class: "text-muted fs-6 mb-5" }
const _hoisted_76 = { class: "mb-6" }
const _hoisted_77 = { class: "fs-2x fw-bolder text-gray-900" }
const _hoisted_78 = { class: "fs-6 text-muted" }
const _hoisted_79 = { class: "list-unstyled text-gray-700 fs-6 mb-8" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot bg-success me-3" }, null, -1)
const _hoisted_81 = {
  key: 0,
  class: "alert alert-warning text-center mt-auto mb-0 py-3 fs-7"
}
const _hoisted_82 = ["disabled", "onClick"]
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { key: 1 }
const _hoisted_85 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.stats && _ctx.stats.totalActions > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              (_ctx.stats.activeSince)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.activeDuration(_ctx.stats.activeSince)) + " aktifsiniz ", 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_ctx.minutesSaved > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.formatDuration(_ctx.minutesSaved)), 1)
                      ]),
                      _hoisted_14,
                      _hoisted_15
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.minutesSaved > 0 ? 'col-lg-7' : 'col-12')
              }, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.fmt(_ctx.stats.totalActions)), 1),
                      _hoisted_20
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.fmt(_ctx.stats.productToggleCount)), 1),
                      _createElementVNode("div", _hoisted_24, [
                        _hoisted_25,
                        (_ctx.stats.productToggleProductCount)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, " (" + _toDisplayString(_ctx.fmt(_ctx.stats.productToggleProductCount)) + " farklı ürün) ", 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.fmt(_ctx.stats.priceUpdateCount)), 1),
                      _createElementVNode("div", _hoisted_30, [
                        _hoisted_31,
                        (_ctx.stats.priceUpdateProductCount)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_32, " (" + _toDisplayString(_ctx.fmt(_ctx.stats.priceUpdateProductCount)) + " farklı ürün) ", 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.fmt(_ctx.stats.optionToggleCount)), 1),
                      _hoisted_36
                    ])
                  ]),
                  (_ctx.stats.commentReplyCount)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.fmt(_ctx.stats.commentReplyCount)), 1),
                          _hoisted_40
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.stats.automatedActionCount)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.fmt(_ctx.stats.automatedActionCount)), 1),
                          _hoisted_44
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 2)
            ]),
            _hoisted_45
          ]))
        : _createCommentVNode("", true),
      (_ctx.subscription && _ctx.subscription.active && !_ctx.subscription.cancelAtPeriodEnd)
        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _hoisted_49,
                _createElementVNode("div", _hoisted_50, [
                  _createTextVNode(_toDisplayString(_ctx.planLabel(_ctx.subscription.plan)) + " — " + _toDisplayString(_ctx.subscription.interval === "year" ? "Yıllık" : "Aylık") + " ", 1),
                  (_ctx.subscription.expireDate)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_51, " · Sonraki yenileme: " + _toDisplayString(_ctx.formatDate(_ctx.subscription.expireDate)), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("button", {
                class: "btn btn-sm btn-light-danger",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancelSubscription && _ctx.cancelSubscription(...args)))
              }, " Aboneliği İptal Et ")
            ])
          ]))
        : (_ctx.subscription && _ctx.subscription.active && _ctx.subscription.cancelAtPeriodEnd)
          ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _hoisted_54,
                _createElementVNode("div", _hoisted_55, [
                  _createTextVNode(_toDisplayString(_ctx.planLabel(_ctx.subscription.plan)) + " paketiniz ", 1),
                  (_ctx.subscription.expireDate)
                    ? (_openBlock(), _createElementBlock("b", _hoisted_56, _toDisplayString(_ctx.formatDate(_ctx.subscription.expireDate)), 1))
                    : _createCommentVNode("", true),
                  _hoisted_57
                ])
              ])
            ]))
          : (_ctx.subscription && _ctx.subscription.viewOnly)
            ? (_openBlock(), _createElementBlock("div", _hoisted_58, _hoisted_60))
            : (_openBlock(), _createElementBlock("div", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, [
                  _hoisted_63,
                  _createElementVNode("div", _hoisted_64, [
                    (_ctx.subscription && _ctx.subscription.grandfatherUntil)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.subscription.grandfatherUntil)) + " tarihine kadar tüm özellikleri kullanabilirsiniz. Bu tarihten sonra işlemlere devam edebilmek için bir abonelik planı seçmeniz gerekir. ", 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])),
      _createElementVNode("div", _hoisted_65, [
        _createElementVNode("div", _hoisted_66, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn", _ctx.interval === 'month' ? 'btn-primary' : 'btn-light']),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.interval = 'month'))
          }, " Aylık ", 2),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn", _ctx.interval === 'year' ? 'btn-primary' : 'btn-light']),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.interval = 'year'))
          }, _hoisted_69, 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_70, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tiers, (tier) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-md-6",
            key: tier.plan
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["card h-100", 
              _ctx.isCurrent(tier.plan)
                ? 'border border-2 border-primary'
                : 'border border-1 border-gray-300'
            ])
            }, [
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("h2", _hoisted_73, _toDisplayString(tier.title), 1),
                  (_ctx.isCurrent(tier.plan))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_74, "Mevcut Plan"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("p", _hoisted_75, _toDisplayString(tier.subtitle), 1),
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("span", _hoisted_77, " $" + _toDisplayString(_ctx.priceFor(tier.plan)), 1),
                  _createElementVNode("span", _hoisted_78, " / " + _toDisplayString(_ctx.interval === "year" ? "yıl" : "ay"), 1)
                ]),
                _createElementVNode("ul", _hoisted_79, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tier.features, (f, i) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: i,
                      class: "d-flex align-items-center mb-3"
                    }, [
                      _hoisted_80,
                      _createTextVNode(_toDisplayString(f), 1)
                    ]))
                  }), 128))
                ]),
                (_ctx.notEligible(tier))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_81, _toDisplayString(_ctx.subscription.integrationCount) + " adet entegrasyonunuz olduğu için bu pakete uygun değilsiniz. ", 1))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "btn btn-primary mt-auto",
                      disabled: _ctx.loadingKey === _ctx.keyFor(tier.plan),
                      onClick: ($event: any) => (_ctx.subscribe(tier.plan))
                    }, [
                      (_ctx.loadingKey === _ctx.keyFor(tier.plan))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_83, " Yönlendiriliyor... "))
                        : (_ctx.isCurrent(tier.plan))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_84, "Planı Yenile / Değiştir"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_85, "Abone Ol"))
                    ], 8, _hoisted_82))
              ])
            ], 2)
          ]))
        }), 128))
      ])
    ])
  ]))
}